import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import Service1 from "../Assets/Images/New Images/Service1.webp";
import Service2 from "../Assets/Images/New Images/Service2.webp";
import Service3 from "../Assets/Images/New Images/Service3.webp";
import Service4 from "../Assets/Images/New Images/Service4.webp";
import Service5 from "../Assets/Images/New Images/Service5.webp";
import Service6 from "../Assets/Images/New Images/Service6.webp";
import Service7 from "../Assets/Images/New Images/Service7.webp";

const services = [
  { title: "Water Extraction & Structural Drying", image: Service1, price: 39 },
  { title: "Dehumidification & Air Movers", image: Service2, price: 39 },
  { title: "Mold Prevention & Remediation", image: Service3, price: 59 },
  { title: "Sewage Cleanup (Black Water)", image: Service4, price: 59 },
  { title: "Content Cleaning & Pack Out", image: Service5, price: 39 },
  { title: "Drywall & Flooring Repair", image: Service6, price: 39 },
  { title: "Emergency Tarps & Roof Leak Response", image: Service7, price: 39 },
];

// duplicate for seamless loop
const loopedServices = [...services, ...services];

export default function ServicesCarousel() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const itemsPerView = isXs ? 1 : isSm ? 2 : 3;

  const [offset, setOffset] = useState(0);
  const [paused, setPaused] = useState(false);
  const speed = 0.02; // smaller = slower

  useEffect(() => {
    if (paused) return;

    const interval = setInterval(() => {
      setOffset((prev) => {
        const resetPoint = (services.length * 100) / itemsPerView;
        return prev >= resetPoint ? 0 : prev + speed;
      });
    }, 16);

    return () => clearInterval(interval);
  }, [paused, itemsPerView]);

  return (
    <Box sx={{ py: 6, backgroundColor: "#fdfbf5", overflow: "hidden" }}>
      <Box
        sx={{ maxWidth: "100%", mx: "auto", px: { xs: 2, md: 6 } }}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
      >
        <Box sx={{ overflow: "hidden" }}>
          <Box
            sx={{
              display: "flex",
              gap: 3,
              transform: `translateX(-${offset}%)`,
              transition: paused ? "transform 0.3s ease" : "none",
              width: `${(loopedServices.length * 100) / itemsPerView}%`,
            }}
          >
            {loopedServices.map((service, i) => (
              <Box
                key={i}
                sx={{
                  flex: `0 0 ${100 / loopedServices.length}%`,
                  backgroundColor: "#fff",
                  borderRadius: 3,
                  overflow: "hidden",
                  display: "flex",
                  cursor: "pointer",
                  transition: "all 0.35s ease",
                  boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
                  "&:hover": {
                    transform: "translateY(-8px) scale(1.02)",
                    boxShadow: "0 18px 40px rgba(0,0,0,0.15)",
                  },
                }}
              >
                {/* Image */}
                <Box
                  sx={{
                    width: "50%",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="img"
                    src={service.image}
                    alt={service.title}
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.5s ease",
                      "&:hover": {
                        transform: "scale(1.1)",
                      },
                    }}
                  />
                </Box>

                {/* Content */}
                <Box
                  sx={{
                    p: 2.5,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    flex: 1,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, mb: 2 }}
                  >
                    {service.title}
                  </Typography>

                  <Button
                    variant="outlined"
                    size="small"
                    sx={{
                      borderRadius: 999,
                      borderColor: "#1fba68",
                      color: "#1fba68",
                      textTransform: "none",
                      px: 3,
                      fontWeight: 600,
                      alignSelf: "flex-start",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        backgroundColor: "#1fba68",
                        color: "#fff",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    From ${service.price}
                  </Button>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
